import type { FaqItem } from '@/content/faq'

export function FaqList({ faqs }: { faqs: FaqItem[] }) {
  return (
    <section className="border-t border-border pt-16 md:pt-24">
      <p className="mb-4 text-xs uppercase tracking-[0.3em] text-accent">FAQ</p>
      <h2 className="mb-10 font-serif text-3xl tracking-tight text-foreground md:text-5xl">
        Common questions
      </h2>
      <dl className="space-y-8">
        {faqs.map((faq) => (
          <div key={faq.question}>
            <dt className="font-serif text-xl text-foreground">{faq.question}</dt>
            <dd className="mt-2 max-w-3xl leading-relaxed text-muted-foreground">{faq.answer}</dd>
          </div>
        ))}
      </dl>
    </section>
  )
}
